import React, { PropTypes } from 'react';
import { get, isNil, pick } from 'lodash';

import ToggleButton from '../../../../../../common/components/c_ToggleButton';
import DropDownMenu from '../../../../../../common/components/c_DropDownMenu';
import ProgressComponent from '../../../../../../common/components/C_ProgressComponent';
import { connect } from 'react-redux';

@connect(store => {
  return {
    labels: get(store, 'labels.HomeOfficeSetup', {})
  };
}, undefined, undefined, { withRef: true })
export default class HomeOfficeSetup extends ProgressComponent {
  static propTypes = {
    profile: PropTypes.object.isRequired,
    model: PropTypes.string.isRequired,
    staticData: PropTypes.object.isRequired,
    tempState: PropTypes.object.isRequired,
    validation: PropTypes.object.isRequired,
    errorUpdate: PropTypes.func.isRequired
  }

  static defaultProps = {
    profile: {}
  }

  constructor(props, context) {
    super(props, context);
    this.handleDropDownMenuUI = ::this.handleDropDownMenuUI;
    this.handleDropDownMenuStaticUI = ::this.handleDropDownMenuStaticUI;

    this.state = {
      validation: Object.assign(
        this.CustomValidation,
        pick(props.validation, [
          'hasDedicatedHomeOffice',
          'computerTypeId',
          'computerOperatingSystemId',
          'hasHighSpeedInternet',
          'canUpgradeTechnology'
        ])
      )
    };

  }

  get CustomValidation() {
    const comp = this;
    const CustomValidator = function() {
      const model = () => Object.assign({}, get(comp, 'props.profile'), get(comp, `props.tempState[${comp.props.model}]`));
      this.internetTypeId = {
        custom: {
          func: (val) => isNil(model().hasHighSpeedInternet) || !model().hasHighSpeedInternet || val,
          message: 'This field is required.'
        }
      };
    };

    return new CustomValidator();
  }

  handleDropDownMenuUI(prop, staticDataProp, label) {
    return {
      'data-id': prop,
      key: `${prop}_${this.props.profile[prop]}`,
      defaultValue: this.props.profile[prop],
      menuItems: this.props.staticData[staticDataProp],
      floatingLabelText: label,
      errorText: get(this.state, `validation.${prop}.errors[0]`),
      onChange:this.validateUpdate(this.props.model, prop, this.updateTempState)
    };
  }

  handleDropDownMenuStaticUI(prop, staticData, label) {
    return {
      'data-id': prop,
      key: `${prop}_${this.props.profile[prop]}`,
      defaultValue: this.props.profile[prop],
      menuItems: staticData,
      floatingLabelText: label,
      errorText: get(this.state, `validation.${prop}.errors[0]`),
      onChange: this.validateUpdate(this.props.model, prop, this.updateTempState)
    };
  }

  render() {
    return (
      <div className='application-section-container expanded-accordion-content clearfix'>
        <div className='form-heading'>
          Home Office Setup
        </div>
        {
          this.props.adminView
          &&
          <div className='callout'>
            Instructions: The questions in this section were asked on the application.
          </div>
        }
        {
          this.props.adminView && this.props.script
          &&
          <div className='speaking-callout'>
          {this.props.labels.speakingCallout}
          {
              (
                !isNil(get(this.props.tempState, 'profile.computerOperatingSystemId')) ?
                  get(this.props.tempState, 'profile.computerOperatingSystemId') === 2 :
                  this.props.profile.computerOperatingSystemId === 2
              )
              &&
            <p>You may need to purchase a PC, which costs about $350 as most systems do not have remote work capabilities with Apple products.</p>
            }
          </div>
        }
        <div className='form-contents home-office-form'>
          <div className='box'>
            <ToggleButton
              {
                ...this.handleDropDownMenuStaticUI(
                  'hasDedicatedHomeOffice', this.booleanDropDown, 'Do you have an area in your home that can be setup as a dedicated, noise free home office?'
                )
              }
            />
          </div>
          <div className='box'>
            <ToggleButton
              {...this.handleDropDownMenuUI('computerTypeId', 'computerTypes', 'What type of computer do you have?')}
            />
          </div>
          <div className='box'>
            <ToggleButton
              {...this.handleDropDownMenuUI('computerOperatingSystemId', 'operatingSystemTypes', 'Is your computer a PC or a Mac?')}
            />
          </div>
          <div className='box'>
            <ToggleButton
              {
                ...this.handleDropDownMenuStaticUI(
                  'canUpgradeTechnology', this.booleanDropDown, 'If your computer and/or internet connections do not meet the requirements for remote work, would you be willing to upgrade and purchase the necessary technology?'
                )
              }
            />
          </div>
          <div className='box'>
            <ToggleButton
              className ='high-speed-internet'
              {
                ...this.handleDropDownMenuStaticUI(
                  'hasHighSpeedInternet', this.booleanDropDown, 'Do you have a high-speed internet connection?'
                )
              }
            />
          </div>
          <div className='box'>
            {
              (
                !isNil(get(this.props.tempState, 'profile.hasHighSpeedInternet')) ?
                get(this.props.tempState, 'profile.hasHighSpeedInternet') === true :
                this.props.profile.hasHighSpeedInternet === true
              )
              &&
              <DropDownMenu
                canAutoPosition='true'
                className='internet-type'
                {...this.handleDropDownMenuUI('internetTypeId', 'internetTypes', 'What is your high-speed internet service type?')}
              />
            }
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./shared/react/r_ApplicantDashboard/f_Application/r_ApplicationForm/Preferences/c_HomeOfficeSetup/index.js